import type { AudienceBuilderTestGroup } from '@highlight-cp/project-api';

/** Suffix for Highlighter survey task-type custom variables (e.g. "Video_assigned"). */
export const TASK_VARIABLE_SUFFIX = '_assigned';

/**
 * ### getTaskVariablesFromTestGroups
 *
 * @description
 * Extracts unique task variable names from recruiting test groups by mapping
 * each task type to "{taskType}_assigned".
 *
 * @param testGroups - Test groups from recruiting data (e.g. spec.audience.testGroups)
 * @returns Deduplicated array of task variable strings
 */
export const getTaskVariablesFromTestGroups = (
  testGroups: AudienceBuilderTestGroup[] | null | undefined,
): string[] => {
  const groups = testGroups ?? [];
  return [
    ...new Set(
      groups.flatMap((group) =>
        (group.tasks ?? [])
          .filter((task) => task.type != null && task.type !== '')
          .map((task) => `${String(task.type)}${TASK_VARIABLE_SUFFIX}`),
      ),
    ),
  ];
};
